export const routes = [
	{
		'title': 'سفارش خرده فروشی',
		'icon': 'mx-3 fa fa-plus-circle',
		'hidden': 'loggedOut',
		'module': 'Retail_Orders',
		'children': [
			{
				'title': 'لیست سفارش خرده فروشی',
				'icon': 'mx-3 fa fa-minus',
				'path': '/list/Retail_Orders',
			},
			{
				'title': 'ایجاد سفارش خرده فروشی',
				'icon': 'mx-3 fa fa-minus',
				'path': '/dynamic/CreateRetail_Orders',
			},
		]
	}
]
